import React from 'react';

import Dialog from '@ts-core/components/Dialog';

import PracticeSessionForm, { PracticeSessionFormProps } from '../PracticeSessionForm';

export interface CreatePracticeSessionDialogProps {
  dialogProps: any;
  practiceSessionFormProps: PracticeSessionFormProps;
}

const CreatePracticeSessionDialog = (props: CreatePracticeSessionDialogProps) => {
  const { dialogProps, practiceSessionFormProps } = props;

  return (
    <Dialog {...dialogProps}>
      <PracticeSessionForm {...practiceSessionFormProps} />
    </Dialog>
  );
};

export default CreatePracticeSessionDialog;
